<template>
  <div class="animated fadeIn">
    <CardTable
      :title="title"
      :columns="table.columns"
      :rows="table.rows"
      :isLoading="table.isLoading"
      :pageSize="serverParams.pageSize"
      :pageNumber="serverParams.pageNumber"
      :totalPage="table.totalPage"
      :totalRecords="table.totalRecords"
      @onRowSelected="onRowSelected"
      @onPageChange="onPageChange"
    >
      <template #action>
        <div class="card-header-actions">
          <b-button :to="{ name: 'AccountManagementCreate' }"
                    size="sm"
                    variant="primary">
            Create New
          </b-button>
          <span style="margin-left: 10px">
            <b-button @click="exportAll"
                      size="sm"
                      variant="primary">
              Export
            </b-button>
          </span>
        </div>
      </template>
      <template #filter>
        <SectionFilter :serverParams="serverParams" @onChange="getAll" />
      </template>
      <template #cell(outstandingBalance)="data">
        {{ numberFormat(data.item.outstandingBalance) }}
      </template>
      <template #cell(meters)="data">
        <b-badge variant="success"
          >{{ data.item.meters.length }} Meters</b-badge
        >
      </template>
      <template #cell(deleted)="data">
        <span v-show="data.item.deleted" class="text-danger">Closed</span>
        <span v-show="!data.item.deleted" class="text-success">Opened</span>
      </template>
    </CardTable>
  </div>
</template>

<script>
import { numberFormat } from "@/shared/utils";
import { accountManagement as columns } from "@/shared/columns";
import SectionFilter from "./SectionFilter.vue";

export default {
  components: {
    SectionFilter,
  },
  data: () => ({
    title: "Account Management",
    serverParams: {
      pageNumber: 1,
      pageSize: 500,
      keyword: null,
      name: null,
      uen: null,
      email: null,
      address: null,
      postalCode: null,
      deleted: false,
      orderBy: "accountId",
    },
    table: {
      isLoading: true,
      columns,
      rows: [],
      totalPage: 0,
      totalRecords: 0,
    },
  }),
  created() {
    const self = this;
    self.getAll();
  },
  methods: {
    numberFormat,
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onRowSelected(items) {
      const self = this;
      self.$router.push({
        name: "AccountManagementUpdate",
        params: {
          id: items[0].accountId,
        },
      });
    },
    onPageChange(params) {
      this.updateParams({ pageNumber: params });
      this.getAll();
    },
    getAll() {
      const self = this;

      self.table.isLoading = true;
      self.$store
        .dispatch("apis/get", {
          url: "/account",
          params: self.serverParams,
        })
        .then((response) => {
          if (response.error) {
            self.$message.error({
              zIndex: 10000,
              message: response.message,
            });
          } else {
            self.table.rows = response.data.data;
            self.table.totalPage = response.data.totalPage;
            self.table.totalRecords = response.data.totalData;
          }
          self.table.isLoading = false;
        });
    },
    exportAll() {
      console.log("export now");
      const self = this;
      self.$store
        .dispatch("apis/download", {
          url: "/account/export",
          params: self.serverParams,
        })
        .then((response) => {
          console.log(response)
          if (response.error) {
            self.$message.error({
              zIndex: 10000,
              message: response.message,
            });
          } else {
            let fileURL = window.URL.createObjectURL(new Blob([response])),
              fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "account-report.xls");
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        });
    },
  },
};
</script>
